/* Tysk katalog for locale-inbox-vouchers-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'voucher.none': 'Keine Belege',
  'voucher.noLedgerLines': 'Noch keine Hauptbuchzeilen vom Backend verfügbar.',
  'voucher.noLedger': 'Keine Hauptbuchzeilen',
  'voucher.action': 'Aktion',
  'voucher.title': 'Transaktionen',
  'voucher.incompleteBasis': 'Die Journalabdeckung ist unvollständig. Die Liste kann zum Nachschlagen von Dokumenten verwendet werden, darf aber nicht als vollständiges Hauptbuch oder vollständige Belegliste gelesen werden.',
  'voucher.subtitle': 'Alle gebuchten Transaktionen des Geschäftsjahres',
  'voucher.backToVat': 'Zurück zur MVA-melding',
  'voucher.showAll': 'Alle Transaktionen anzeigen',
  'voucher.download': 'Herunterladen',
  'voucher.loadingPreview': 'Vorschau wird geladen...',
  'voucher.cannotPreviewUse': 'Die Datei kann hier nicht in der Vorschau angezeigt werden. Verwende „Herunterladen“, um sie zu öffnen.',
  'voucher.cannotPreview': 'Dieser Dateityp kann hier nicht in der Vorschau angezeigt werden.',
  'voucher.invoice': 'Rechnung',
  'voucher.voucher': 'Beleg',
  'voucher.attachmentAttached': 'Beleg angehängt',
  'voucher.commentOptional': 'Kommentar (optional)',
  'voucher.commentPh': 'Z. B. falscher Betrag, Doppelbuchung oder falscher Lieferant.',
  'voucher.view': 'Ansicht',
  'voucher.viewHelp': 'Wechsle zwischen Belegliste, detaillierten Buchungen und nach Konto gruppiertem Hauptbuch.',
  'voucher.view.bilag': 'Belege',
  'voucher.view.detaljer': 'Details',
  'voucher.view.hovedbok': 'Hauptbuch',
  'voucher.searchPh': 'Nach Beleg, Konto oder Betrag suchen',
  'voucher.searchHelp': 'Suche nach Belegnummer, Gegenpartei, Konto/Buchung oder Betrag. Im Hauptbuch kannst du auch nach Soll, Haben und Saldo suchen.',
  'voucher.filterHelp': 'Filtere die Belege nach Typ, Anhang, Zahlungsstatus, Zeitraum und Betrag.',
  'voucher.amountTitle': 'Betrag auf dem Beleg',
  'voucher.amountHelp': 'Netto ist der Betrag ohne MwSt. (der eigentliche Aufwand/Ertrag), MwSt. ist die Steuer und Brutto der Gesamtbetrag inklusive MwSt. Zusammen mit Datum und Belegnummer sind das die wichtigsten Angaben der Buchung.',
  'voucher.rowHelp': 'Jede Zeile ist ein Beleg. Symbol und Label zeigen den Typ (Verkauf, Kauf, Lieferantenrechnung, Gutschrift, manueller Beleg), dazu siehst du Name und Belegnummer. Tippe auf die Zeile, um den Beleg zu öffnen.',
  'voucher.net': 'Netto',
  'voucher.netHelp': 'Der Betrag ohne MwSt. - der eigentliche Aufwand oder Ertrag, der auf ein Konto gebucht wird.',
  'voucher.vat': 'MwSt.',
  'voucher.vatHelp': 'Die Mehrwertsteuer auf dem Beleg - Umsatzsteuer bei Verkäufen, (abzugsfähige) Vorsteuer bei Käufen.',
  'voucher.gross': 'Brutto',
  'voucher.grossHelp': 'Der Gesamtbetrag inklusive MwSt. - netto plus MwSt. Das ist der Betrag, der tatsächlich gezahlt oder empfangen wird.',
  'voucher.accountPh': 'Z. B. Software, Bank oder 6300',
  'voucher.account': 'Konto',
  'voucher.accountHelp': 'Das Konto gibt an, worauf sich die Buchung bezieht - aus dem Kontenplan. Die Kontonummer bestimmt, wo der Betrag in der Buchhaltung landet (1xxx Vermögenswerte, 2xxx Verbindlichkeiten/Eigenkapital, 3xxx Erträge, 4-7xxx Aufwendungen). Tippe auf das Listensymbol, um im Kontenplan zu suchen.',
  'voucher.pickAccount': 'Konto wählen',
  'voucher.searchChart': 'Im Kontenplan suchen...',
  'voucher.noDescription': 'Ohne Beschreibung',
  'voucher.removeEntry': 'Buchung entfernen',
  'voucher.entryDate': 'Belegdatum',
  'voucher.entryDateHelp': 'Das Datum, an dem die Buchung erfasst werden soll. Es bestimmt, in welchen Buchungs- und MwSt.-Zeitraum die Buchung fällt.',
  'voucher.whatFor': 'Worum geht es bei der Buchung?',
  'voucher.whatForHelp': 'Ein kurzer Text, der erklärt, worauf sich die Buchung bezieht. Er erscheint im Hauptbuch und macht die Buchung später leicht verständlich.',
  'voucher.fromAccount': 'Von Konto',
  'voucher.toAccount': 'An Konto',
  'voucher.fromAccountCredit': 'Von Konto (Haben)',
  'voucher.fromAccountHelp': 'Das Konto, VON dem das Geld kommt - die Habenseite der Buchung. Zahlst du z. B. Miete vom Bankkonto, ist die Bank (1920) „Von“. Haben verringert einen Vermögenswert oder erhöht Verbindlichkeiten/Erträge.',
  'voucher.vatCode': 'MwSt.-Code',
  'voucher.vatCodeHelp': 'Der Steuercode bestimmt, wie die MwSt. berechnet und in der MVA-melding gemeldet wird. Code 86 wird für elektronisch erbringbare Dienstleistungen aus dem Ausland verwendet. Wareneinfuhren werden über die Zollanmeldung erfasst.',
  'voucher.swap': 'Von und An tauschen',
  'voucher.swapHelp': 'Tauscht Von- und An-Konto in der Zeile. Nützlich, wenn du Soll und Haben vertauscht hast.',
  'voucher.toAccountDebit': 'An Konto (Soll)',
  'voucher.toAccountHelp': 'Das Konto, AN das das Geld geht - die Sollseite der Buchung. Geht es um Miete, ist das Mietkonto (6300) „An“. Soll erhöht einen Aufwand oder einen Vermögenswert.',
  'voucher.addLineHelp': 'Fügt dieser Buchung eine neue Buchungszeile hinzu. Verwende mehrere Zeilen, wenn der Betrag auf mehrere Konten verteilt werden soll - alle Zeilen zusammen müssen Soll und Haben auf null ausgleichen.',
  'voucher.attachHelp': 'Hänge Dokumentation zur Buchung an - Quittung, Rechnung oder anderen Beleg. Optional, aber empfohlen: Gute Dokumentation macht die Buchhaltung nachprüfbar. Du kannst Dateien hineinziehen oder einen Screenshot einfügen.',
  'voucher.attachOptional': 'Anhänge (optional)',
  'voucher.uploadAttachment': 'Anhang hochladen',
  'voucher.deleteAttachment': 'Anhang löschen',
  'voucher.openNewTab': 'In neuem Tab öffnen',
  'voucher.balance': 'Ausgleich',
  'voucher.balanceHelp': 'Zeigt, ob die Buchung ausgeglichen ist. „Ausgeglichen“ bedeutet, dass die Summe An (Soll) der Summe Von (Haben) entspricht - dann kann die Buchung erfasst werden. Gibt es eine Differenz, korrigiere die Beträge, bis sie null ergeben.',
  'voucher.toDebit': 'An (Soll)',
  'voucher.fromCredit': 'Von (Haben)',
  'voucher.posted': 'Gebucht',
  'voucher.edit': 'Bearbeiten',
  'voucher.newCopy': 'Neue Kopie der freien Buchung',
  'voucher.newFree': 'Neue freie Buchung',
  'voucher.from': 'Von',
  'voucher.to': 'An',
  'voucher.sum': 'Summe',
  'voucher.newEntry': 'Neue Buchung',
  'voucher.newEntryHelp': 'Fügt unter derselben Erfassung eine weitere Buchung (einen neuen Beleg) hinzu. Jede Buchung hat eigenes Datum, eigene Beschreibung und Zeilen und wird als eigener Beleg gebucht.',
  'voucher.postHelp': 'Bucht die Buchung(en) in die Buchhaltung. Die Schaltfläche ist erst aktiv, wenn alle Buchungen ausgeglichen sind - also Soll und Haben null ergeben.',
  'voucher.details': 'Details',
  'voucher.statusBalanced': 'Ausgeglichen',
  'voucher.statusMissingAccount': 'Konto fehlt',
  'voucher.statusSameAccount': 'Gleiches Konto',
  'voucher.statusEmpty': 'Leer',
  'voucher.statusUnbalanced': 'Nicht ausgeglichen',
  'voucher.attachDropHint': 'Dateien hierher ziehen oder einen Screenshot mit Ctrl+V einfügen',
  'voucher.chooseBothAccounts': 'Wähle sowohl Von- als auch An-Konto.',
  'voucher.sameAccountWarning': 'Von- und An-Konto dürfen nicht dasselbe Konto sein.',
  'voucher.balancedReady': 'Ausgeglichen - bereit zur Erfassung',
  'voucher.enterAmount': 'Gib einen Betrag ein.',
  'voucher.difference': 'Differenz: {amount}',
  'voucher.postedTitlePlural': 'Buchungen erfasst',
  'voucher.postedTitleSingular': 'Buchung erfasst',
  'voucher.postedBodyPlural': '{count} Buchungen wurden gebucht.',
  'voucher.postedBodySingular': 'Die Buchung wurde gebucht.',
  'voucher.postedIntro': 'So wurde gebucht:',
  'voucher.descriptionRequired': 'Gib bei allen Buchungen eine Beschreibung ein, bevor du buchst.',
  'voucher.saveFailed': 'Die Buchung konnte nicht erfasst werden.',
  'voucher.backTo': 'Zurück zu {label}',
  'voucher.controlPoint': 'Kontrollpunkt',
  'voucher.editTitle': 'Freie Buchung bearbeiten',
  'voucher.freePosting': 'Freie Buchung',
  'voucher.editSubtitle': 'Aktualisiere die Buchung und speichere die Änderungen im Backend.',
  'voucher.correctPostedTitle': 'Gebuchten Beleg korrigieren',
  'voucher.correctPostedSubtitle': 'Das Original bleibt erhalten. Plumme bucht eine Stornierung und einen neuen Ersatzbeleg in einem Vorgang.',
  'voucher.correctPostedNotice': 'Der ursprüngliche Beleg und die Journalnummer bleiben unverändert. Die Änderung wird als verknüpfte Stornierung und Ersetzung erfasst.',
  'voucher.correctionReason': 'Grund der Korrektur',
  'voucher.correctionReasonPlaceholder': 'Beschreibe, was falsch war und warum der Beleg korrigiert wird',
  'voucher.correctPostedAction': 'Beleg korrigieren',
  'voucher.correctionPreview': 'Korrektur in der Vorschau anzeigen',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Exakte Stornierung',
  'voucher.correctionReplacement': 'Ersatzbeleg',
  'voucher.freePostingSubtitle': 'Manuelle Buchungen - Soll und Haben müssen sich auf null ausgleichen',
  'voucher.freePostingTitleHelp': 'Mit der freien Buchung kannst du manuell direkt auf ein Konto buchen, wenn du volle Kontrolle brauchst - zum Beispiel für Korrekturen, Umbuchungen oder Buchungen, die nicht zu einem normalen Einkauf oder Verkauf passen. Du bestimmst selbst, zwischen welchen Konten der Betrag verschoben wird.',
  'voucher.directVatWarningTitle': 'Warnung: Direktbuchung auf ein MwSt.-Konto',
  'voucher.directVatWarningBody': 'Diese Buchungen werden im Hauptbuch gebucht, aber nicht in die MVA-melding übernommen. Verwende den normalen Einkauf, Verkauf oder die Zollanmeldung, wenn der Betrag als MwSt. gemeldet werden soll.',
  'voucher.directVatExcluded': 'nicht in der MVA-melding enthalten',
  'voucher.directVatConfirmLabel': 'Gib OK ein, um zu bestätigen, dass du die Konsequenz verstehst',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Buchungen erfassen',
  'voucher.registerEntrySingular': 'Buchung erfassen',
  'voucher.registering': 'Wird erfasst...',
  'voucher.creditWord': 'Haben',
  'voucher.debitWord': 'Soll',
  'voucher.attachmentFallbackName': 'anhang',
  'inbox.prevPage': 'Vorherige Seite',
  'inbox.page': 'Seite',
  'inbox.nextPage': 'Nächste Seite',
  'inbox.zoomOut': 'Verkleinern',
  'inbox.zoomIn': 'Vergrößern',
  'inbox.rotate': 'Beleg drehen',
  'inbox.mainDoc': 'Hauptbeleg',
  'inbox.moveTo': 'Verschieben nach',
  'inbox.payOperating': 'Geschäftskonto - 1920',
  'inbox.payCash': 'Bar - 1900',
  'inbox.payPrivate': 'Private Auslage',
  'inbox.payUnknown': 'Zahlungsquelle wählen ...',
  'inbox.suggestion': 'Vorschlag von SuperPlumma',
  'inbox.docType': 'Belegart',
  'inbox.quickChoices': 'Schnellauswahl',
  'inbox.quickChoiceUse': 'Wähle, was die Schnellauswahl ersetzen soll',
  'inbox.quickChoiceRemembered': 'Gemerkt aus früheren Belegen dieses Lieferanten ({count}).',
  'inbox.quickChoiceAccount': 'Konto ersetzen',
  'inbox.quickChoiceDescription': 'Beschreibung ersetzen',
  'inbox.quickChoiceBoth': 'Beides ersetzen',
  'inbox.purchase': 'Einkauf',
  'inbox.supplierInvoice': 'Lieferantenrechnung',
  'inbox.pickSupplier': 'Lieferant wählen',
  'inbox.invoiceNoPh': 'z. B. 0012345',
  'inbox.toggleVatHelp': 'Tippe, um umzuschalten, ob der eingegebene Betrag ohne oder mit MwSt. ist. Plumme rechnet automatisch um und speichert den Bruttobetrag im Belegvorschlag.',
  'inbox.vatDeductionRate': 'Vorgeschlagener Vorsteuerabzug',
  'inbox.documentVatRateHint': 'Der Beleg zeigt {documentRate} % MwSt. Der Vorschlag verwendet {deductionRate} % Abzug auf Basis des MwSt.-Status des Unternehmens und der gewählten Behandlung.',
  'inbox.accountCategory': 'Konto/Kategorie',
  'inbox.accountHelp': 'Der Vorschlag von SuperPlumma ist vorausgewählt. Tippe, um ein anderes Konto zu wählen.',
  'inbox.dueDateFromReceipt': 'Der Beleg hat kein Fälligkeitsdatum. Auf das Belegdatum gesetzt.',
  'inbox.supplierNotSaved': 'Wähle einen gespeicherten Lieferanten oder speichere den Lieferanten, bevor du die Rechnung buchst.',
  'err.purchase.supplierNotSaved': 'Wähle einen gespeicherten Lieferanten oder speichere den Lieferanten, bevor du die Rechnung buchst.',
  'inbox.duplicateTitle': 'Mögliche Doppelbuchung',
  'inbox.duplicateBody': 'Ein Beleg mit demselben Datum und Betrag ist bereits gebucht.',
  'inbox.duplicateSameSupplier': 'Ein Beleg mit demselben Datum, Betrag und Lieferanten ist bereits gebucht.',
  'inbox.duplicateUploadFile': 'Möglicher doppelter Upload: Genau dieselbe Datei liegt bereits im Posteingang.',
  'inbox.duplicateUploadContent': 'Möglicher doppelter Upload: Gleicher Lieferant und Betrag wie ein anderer Beleg im Posteingang, und die Belegdaten liegen innerhalb von 7 Tagen.',
  'inbox.duplicateUploadCount': 'Betrifft andere Belege: {count}.',
  'inbox.setPaymentSource': 'Bezahlt von',
  'inbox.bulkPaymentTitle': 'Bezahlt von',
  'inbox.bulkPaymentLead': 'Die Quelle wird für {count} Belege gesetzt. Du kannst sie danach bei jedem einzelnen Beleg ändern.',
  'inbox.bulkPaymentLabel': 'Bezahlt von',
  'inbox.bulkPaymentHint': 'Die Belege werden mit diesem Konto buchungsbereit.',
  'inbox.bulkPaymentPick': 'Wähle zuerst eine Zahlungsquelle.',
  'inbox.bulkPaymentConfirm': 'Für {count} Belege setzen',
  'inbox.bulkPaymentDone': 'Zahlungsquelle für {count} Belege gesetzt.',
  'inbox.uploadPaymentSingleTitle': 'Bezahlt von',
  'inbox.uploadPaymentBulkTitle': 'Zahlungsquellen zuordnen',
  'inbox.uploadPaymentAppliesTo': 'Gilt für {count} ausgewählte Belege',
  'inbox.uploadPaymentSelectFirst': 'Markiere die Belege unten, dann setzen die Schaltflächen ihre Zahlungsquelle.',
  'inbox.uploadPaymentBank': 'Bank',
  'inbox.uploadPaymentBankSetup': 'Füge zuerst ein Bankkonto hinzu',
  'inbox.uploadPaymentOtherSource': 'Andere Zahlungsquelle wählen ...',
  'inbox.uploadPaymentOperating': 'Geschäftskonto',
  'inbox.uploadPaymentPrivate': 'Privat',
  'inbox.uploadPaymentPrivateRecommended': 'Empfohlen ohne Geschäftskonto',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analysiert',
  'inbox.collectionNotice': 'Inkassomitteilung',
  'inbox.collectionNoticeTitle': 'Dies gehört zum Originalbeleg',
  'inbox.collectionNoticeBody': 'Die Hauptforderung darf nicht erneut gebucht oder mit MwSt. erfasst werden. Verknüpfe die Mitteilung mit dem Originalbeleg; Zinsen und Inkassokosten werden separat ohne MwSt. behandelt.',
  'inbox.collectionNoticePrincipal': 'Hauptforderung',
  'inbox.collectionNoticeInterest': 'Zinsen',
  'inbox.collectionNoticeCosts': 'Inkassokosten',
  'inbox.collectionNoticeCandidates': 'Mögliche Originalbelege',
  'inbox.collectionNoticeLink': 'Verknüpfen',
  'inbox.collectionNoticeLinked': 'Die Inkassomitteilung ist mit dem Originalbeleg verknüpft.',
  'inbox.collectionNoticeLinkFailed': 'Die Inkassomitteilung konnte nicht mit dem Originalbeleg verknüpft werden.',
  'inbox.collectionNoticeOpenOriginal': 'Originalbeleg öffnen',
  'inbox.collectionNoticeNoCandidate': 'Kein sicherer Vorschlag gefunden. Suche die Originalrechnung oder lade sie hoch, bevor die Mitteilung bearbeitet wird.',
  'inbox.collectionNoticeBookBlocked': 'Vor der Bearbeitung mit dem Originalbeleg verknüpfen',
  'inbox.uploadPaymentAssigned': 'Konto {account}',
  'inbox.uploadPaymentUnpaid': 'Noch nicht bezahlt',
  'inbox.uploadPaymentUnpaidHint': 'Für eine Lieferantenrechnung, die bis zur Zahlung als Verbindlichkeit stehen soll.',
  'inbox.uploadPaymentAnalyze': 'Plumme die Zahlungsquelle finden lassen',
  'inbox.uploadPaymentUnassigned': 'Nicht geklärt',
  'inbox.uploadPaymentSelectVisible': 'Angezeigte auswählen',
  'inbox.uploadPaymentShowAll': 'Alle anzeigen',
  'inbox.uploadPaymentShowPending': 'Nur ungeklärte anzeigen',
  'inbox.uploadPaymentProgress': '{completed} von {count} geklärt',
  'inbox.uploadPaymentConfirm': '{count} hochladen',
  'inbox.uploadPaymentReceipt': 'Beleg',
  'inbox.cardNudgeTitle': 'Belege ohne Zahlungsquelle: {count}',
  'inbox.cardNudgeText': 'Hinterlege die Karten bei den Bankkonten, dann erkennt Plumme die Zahlung direkt am Beleg. Die Kontoart entscheidet, ob der Einkauf geschäftlich oder eine private Auslage ist.',
  'inbox.cardNudgeAction': 'Karten hinterlegen',
  'inbox.shortDescription': 'Kurze Beschreibung des Belegs',
  'inbox.shrinkPreview': 'Vorschau verkleinern',
  'inbox.growPreview': 'Vorschau vergrößern',
  'inbox.dragWidth': 'Ziehen, um die Breite zu ändern',
  'inbox.sendTo': 'Senden an:',
  'inbox.filterStatus': 'Status',
  'inbox.filterBankConnection': 'Bankverbindung',
  'inbox.filterReadyToPost': 'Buchungsbereit',
  'inbox.filterNeedsReview': 'Zur Prüfung',
  'inbox.filterAwaitingAnalysis': 'Wartet auf Analyse',
  'inbox.toInbox': 'In den Posteingang (Belege)',
  'inbox.toDocumentation': 'Zur Dokumentation',
  'inbox.selectAll': 'Alle auswählen',
  'inbox.selectHint': 'Umschalt-Klick, um mehrere in Folge auszuwählen',
  'inbox.reviewSelected': 'Buchung starten ({count})',
  'inbox.planTitle': 'Mit SuperPlumma buchen',
  'inbox.planLead': '{count} von {selected} ausgewählten Belegen werden jetzt gebucht.',
  'inbox.planNothing': 'Keiner der ausgewählten Belege kann in seinem aktuellen Zustand gebucht werden.',
  'inbox.planWithNotes': '{count} mit vorausgewählter Zahlungsquelle',
  'inbox.planConfirm': '{count} Belege buchen',
  'inbox.planShow': 'Anzeigen',
  'inbox.planHide': 'Ausblenden',
  'inbox.planSameFile': 'Gesperrt: Genau dieselbe Datei ist bereits vorhanden ({count})',
  'inbox.planSameInvoiceNumber': 'Gesperrt: Die Rechnungsnummer ist bereits erfasst ({count})',
  'inbox.planSameContent': 'Übersprungen: möglicher doppelter Upload ({count})',
  'inbox.planNeedsReview': 'Übersprungen: Prüfung erforderlich ({count})',
  'inbox.planMissingData': 'Übersprungen: fehlende Daten ({count})',
  'inbox.planMissing': 'Übersprungen: nicht mehr vorhanden ({count})',
  'inbox.planAllowContent': 'Trotzdem buchen - ich habe geprüft, dass es verschiedene Einkäufe sind',
  'inbox.planAllowContentWarn': 'Die Duplikate werden als separate Belege gebucht. Prüfe, ob das stimmt, bevor du fortfährst.',
  'inbox.planResultTitle': 'Buchung abgeschlossen',
  'inbox.planResultLead': '{booked} von {selected} ausgewählten Belegen wurden gebucht.',
  'inbox.planBooked': 'Gebucht ({count})',
  'inbox.planSkipped': 'Übersprungen ({count})',
  'inbox.planFailed': 'Fehlgeschlagen ({count})',
  'inbox.walkTitle': 'Belege buchen',
  'inbox.walkLead': '{count} Belege in der Warteschlange.',
  'inbox.walkReady': 'Bereit',
  'inbox.walkNeedsReview': 'Prüfung nötig',
  'inbox.walkDuplicates': 'Mögliche Duplikate',
  'inbox.walkDuplicateOf': 'Identisch mit {names}.',
  'inbox.walkHint': 'Du kannst jederzeit schließen - was du noch nicht bearbeitet hast, bleibt ausgewählt.',
  'inbox.walkStart': 'Alle {count} durchgehen',
  'inbox.walkBookReady': 'Die {count} bereiten jetzt buchen',
  'inbox.walkPosition': '{index} von {total}',
  'inbox.walkPause': 'Später fortsetzen',
  'inbox.walkTrash': 'In den Papierkorb',
  'inbox.walkSkip': 'Überspringen',
  'inbox.walkNext': 'Weiter',
  'inbox.walkGone': 'Der Beleg ist nicht mehr da',
  'inbox.walkGoneText': 'Er wurde gebucht, gelöscht oder verschoben, während die Durchsicht geöffnet war.',
  'inbox.walkDoneTitle': 'Durchsicht abgeschlossen',
  'inbox.walkDoneLead': '{count} Belege durchgesehen',
  'inbox.walkDoneCounts': '{booked} gebucht, {skipped} übersprungen, {trashed} in den Papierkorb verschoben.',
  'inbox.clearSelection': 'Auswahl aufheben',
  'inbox.restoreAll': 'Alle wiederherstellen',
  'inbox.deletePermanently': 'Endgültig löschen',
  'inbox.deleteAll': 'Alle löschen',
  'inbox.downloadAll': 'Ausgewählte herunterladen',
  'inbox.downloading': 'Wird heruntergeladen...',
  'inbox.postAllWithAi': 'Alle mit SuperPlumma buchen',
  'inbox.postWithAi': '{count} mit SuperPlumma buchen',
  'inbox.postNoneReady': 'Keiner der ausgewählten Belege ist buchungsbereit. Verwende „Buchung starten“, um sie einzeln zu bearbeiten.',
  'inbox.uploadDocument': 'Dokument hochladen',
  'inbox.mergeToOne': 'Zu einem Beleg zusammenführen',
  'inbox.dragToMerge': 'Ziehen, um Belege zusammenzuführen',
  'inbox.restore': 'Wiederherstellen',
  'inbox.post': 'Buchen',
  'inbox.archiveNote': 'Archiv für Dokumente, die nicht als Beleg gebucht werden sollen.',
  'inbox.searchDocs': 'Dokumente durchsuchen...',
  'inbox.moveToTrash': 'In den Papierkorb verschieben',
  'inbox.defaultVoucherName': 'Beleg',
  'inbox.defaultDocumentName': 'Dokument',
  'inbox.docTypeSettlement': 'Abrechnung',
  'inbox.docTypeSupplierInvoice': 'Lieferantenrechnung',
  'inbox.docTypeSaleVoucher': 'Verkaufsbeleg',
  'inbox.docTypePurchaseVoucher': 'Einkaufsbeleg',
  'inbox.paySourcePrivate': 'Privat bezahlt',
  'inbox.paySourceCash': 'Bar',
  'inbox.paySourceUnclear': 'Ungeklärte Zahlung',
  'inbox.paySourceCompany': 'Firmenkonto',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % MwSt. auf dem Beleg · {deductionRate} % Abzug',
  'inbox.vatRateLabel': '{rate} % MwSt.',
  'inbox.paidFromBank': 'Von der Bank bezahlt',
  'inbox.supplierNotRead': 'Unternehmen nicht erkannt',
  'inbox.invoiceNumberLabel': 'Rechnung {number}',
  'inbox.attachmentLinkMissing': 'Für den Anhang ist kein Link verfügbar.',
  'inbox.menuNewPurchase': 'Bezahlter Einkauf',
  'inbox.menuFixedAsset': 'Anlagegut',
  'inbox.menuOtherSale': 'Sonstiger Verkauf',
  'inbox.menuOpenAttachment': 'Anhang öffnen',
  'inbox.menuDownload': 'Herunterladen',
  'inbox.menuSplitAgain': 'Wieder aufteilen',
  'inbox.reanalyze': 'Erneut analysieren',
  'inbox.analyze': 'Analysieren',
  'inbox.previewDocumentFallback': 'Dokument',
  'inbox.previewMissingFileLink': 'Datei-Link fehlt',
  'inbox.saveNotConnected': 'Das Speichern von Belegvorschlägen ist nicht mit dem Backend verbunden.',
  'inbox.suggestionUpdated': 'Der Belegvorschlag wurde aktualisiert.',
  'inbox.suggestionSaveFailed': 'Der Belegvorschlag konnte nicht gespeichert werden.',
  'inbox.settlementFromLabel': 'Abrechnung von',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'Abrechnungs-ID',
  'inbox.settlementNetToBankLabel': 'Netto an Bank',
  'inbox.suggestedInvoiceSingular': 'Vorgeschlagene Rechnung',
  'inbox.suggestedInvoicePlural': 'Mehrere mögliche Rechnungen',
  'inbox.selectInvoiceManually': 'Rechnung manuell wählen',
  'inbox.paidToggleOn': 'Bezahlt',
  'inbox.paidToggleOff': 'Nicht bezahlt – wird als Lieferantenverbindlichkeit gebucht',
  'inbox.paidToLabel': 'Bezahlt an',
  'inbox.projectSaveFailed': 'Das Projekt konnte nicht gespeichert werden.',
  'inbox.awaitingOcrData': 'Warte auf OCR-Daten',
  'inbox.showSuggestionAgain': 'Vorschlag erneut anzeigen',
  'inbox.maximizePreview': 'Vorschau maximieren',
  'inbox.uploadPartialAnalyzing': '{done} von {total} Belegen wurden hochgeladen. Die eingegangenen werden analysiert ...',
  'inbox.uploadedSingle': 'Beleg hochgeladen.',
  'inbox.uploadedMultipleAnalyzing': '{count} Belege hochgeladen. Analyse läuft ...',
  'inbox.uploadFailedSingle': 'Der Beleg konnte nicht hochgeladen werden.',
  'inbox.uploadFailedMultiple': 'Die Belege konnten nicht hochgeladen werden.',
  'inbox.uploadFailedGeneric': 'Belege konnten nicht hochgeladen werden.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} Belege bleiben als „Wartet auf Analyse“ stehen.',
  'inbox.uploadedButAnalysisFailedSingle': 'Der Beleg wurde hochgeladen, aber die Analyse ist fehlgeschlagen.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Die Belege wurden hochgeladen, aber die Analyse ist fehlgeschlagen.',
  'inbox.partialAnalysisFailed': '{failed} von {total} Belegen wurden nicht analysiert. Versuche „Analysieren“ in der Zeile.',
  'inbox.documentAddedSingle': 'Dokument zu Dokumentation hinzugefügt.',
  'inbox.documentAddedMultiple': 'Die Dokumente wurden zu Dokumentation hinzugefügt.',
  'inbox.documentUploadFailed': 'Dokument konnte nicht hochgeladen werden.',
  'inbox.analyzed': 'Der Beleg wurde analysiert.',
  'inbox.analyzeActionFailed': 'Die Beleganalyse ist fehlgeschlagen.',
  'inbox.bookedNoneReason': 'Es wurden keine Belege gebucht.',
  'inbox.bookedSummary': '{booked} gebucht, {skipped} übersprungen.',
  'inbox.bookedOne': 'Der Beleg wurde gebucht.',
  'inbox.bookedCount': '{count} Belege gebucht.',
  'inbox.bookFailedFallback': 'Die Belege konnten nicht gebucht werden.',
  'inbox.setPaymentSourceFailed': 'Die Zahlungsquelle konnte nicht festgelegt werden.',
  'inbox.moveToTrashFailed': 'Beleg konnte nicht verschoben werden.',
  'inbox.movedToTrash': 'Beleg in den Papierkorb verschoben.',
  'inbox.movedToTrashCount': '{count} Belege in den Papierkorb verschoben.',
  'inbox.restoredOne': 'Beleg wiederhergestellt.',
  'inbox.restoredCount': '{count} Belege wiederhergestellt.',
  'inbox.restoreFailed': 'Beleg konnte nicht wiederhergestellt werden.',
  'inbox.confirmDeletePermanentOne': 'Beleg endgültig löschen?',
  'inbox.confirmDeletePermanentMany': 'Ausgewählte Belege endgültig löschen?',
  'inbox.deletedPermanently': 'Beleg endgültig gelöscht.',
  'inbox.deleteFailed': 'Beleg konnte nicht gelöscht werden.',
  'inbox.docMovedToTrash': 'Dokument in den Papierkorb verschoben.',
  'inbox.docMovedToTrashCount': '{count} Dokumente in den Papierkorb verschoben.',
  'inbox.docMoveToTrashFailed': 'Dokument konnte nicht verschoben werden.',
  'inbox.docRestored': 'Dokument wiederhergestellt.',
  'inbox.docRestoredCount': '{count} Dokumente wiederhergestellt.',
  'inbox.docRestoreFailed': 'Dokument konnte nicht wiederhergestellt werden.',
  'inbox.confirmDeleteDocOne': 'Dokument endgültig löschen?',
  'inbox.confirmDeleteDocMany': 'Ausgewählte Dokumente endgültig löschen?',
  'inbox.docDeletedPermanently': 'Dokument endgültig gelöscht.',
  'inbox.docDeleteFailed': 'Dokument konnte nicht gelöscht werden.',
  'inbox.downloadPartial': '{downloaded} von {total} Dateien wurden heruntergeladen. Der Rest konnte nicht abgerufen werden.',
  'inbox.downloadedZip': '{count} Dateien als ZIP heruntergeladen.',
  'inbox.downloadedSingleFile': 'Die Datei wurde heruntergeladen.',
  'inbox.downloadFilesFailed': 'Die Dateien konnten nicht heruntergeladen werden.',
  'inbox.movedToDocs': 'Beleg nach Dokumentation verschoben.',
  'inbox.movedToDocsCount': '{count} Belege nach Dokumentation verschoben.',
  'inbox.moveToDocsFailed': 'Beleg konnte nicht nach Dokumentation verschoben werden.',
  'inbox.mergedCount': '{count} Belege zusammengeführt.',
  'inbox.mergeFailed': 'Belege konnten nicht zusammengeführt werden.',
  'inbox.splitAgainDone': 'Der Beleg wurde wieder aufgeteilt.',
  'inbox.splitAgainFailed': 'Beleg konnte nicht aufgeteilt werden.',
  'inbox.addressCopied': 'Belegadresse kopiert.',
  'inbox.trashTitle': 'Papierkorb',
  'inbox.docsSubtitle': 'Archiv für Vereinbarungen, Verträge und Dokumente - keine Belege zum Buchen.',
  'inbox.inboxSubtitle': 'Lade Belege hoch oder leite sie per E-Mail weiter - wir lesen aus, was wir können.',
  'inbox.titleHelp': 'Der Posteingang ist der Sammelort für eingegangene, aber noch nicht gebuchte Belege. Lade Dateien hoch oder leite Quittungen und Rechnungen per E-Mail weiter - SuperPlumma liest den Inhalt aus und macht sie buchungsbereit.',
  'inbox.docsWithCount': 'Dokumentation ({count})',
  'inbox.trashWithCount': 'Papierkorb ({count})',
});
